module.exports = __webpack_public_path__ + "img/vue1-semelle_noir.fc929f3c.png";